import { OwaDate, addDays, addHours, now, startOfDay } from 'owa-datetime';

/**
 * Retrieves the default reminder time to initialize in the reminder picker with.
 * @param nowToUse Reference now time for unit testing
 */
export default function getDefaultReminderDateTime(nowToUse: OwaDate): OwaDate {
    const nowDateTime = nowToUse ? nowToUse : now();
    const today = startOfDay(nowDateTime);
    const tomorrow = addDays(today, 1);
    const defaultReminderDateTime = addHours(tomorrow, 11);

    return defaultReminderDateTime;
}
